<template>
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :title="meunTitle"></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="main_head">
            <div class="main_head_left">
              <div>
                <div class="input_parent">
                  <el-input
                    class="input"
                    v-model="where_student_no"
                    placeholder="请输入"
                    size
                  ></el-input>
                  <span>学号:</span>
                </div>
                <div class="input_parent">
                  <el-input
                    class="input"
                    v-model="where_name"
                    placeholder="请输入"
                    size
                  ></el-input>
                  <span>姓名:</span>
                </div>
                <div class="input_parent">
                  <el-select
                    class="input"
                    v-model="where_programme"
                    placeholder="请选择"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="item in programmeOptions"
                      :key="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                  <span>专业:</span>
                </div>
                <div class="input_parent">
                  <el-input
                    class="input"
                    v-model="where_content"
                    placeholder="请输入"
                    size
                  ></el-input>
                  <span>捐助内容:</span>
                </div>
              </div>

              <div v-show="queryMoreShowFlag">
                <div class="input_parent">
                  <el-input
                    class="input"
                    v-model="where_money"
                    placeholder="请输入"
                    size
                  ></el-input>
                  <span>捐助金额:</span>
                </div>
                <div class="input_parent">
                  <el-select
                    class="input"
                    v-model="where_type"
                    placeholder="请选择"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="item in journalTypeOptions"
                      :key="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                  <span>捐助类型:</span>
                </div>
                <div class="input_parent">
                  <el-input
                    class="input"
                    v-model="where_remark"
                    placeholder="请输入"
                    size
                  ></el-input>
                  <span>备注:</span>
                </div>
                <div class="input_parent">
                  <el-select
                    class="input"
                    v-model="where_relation"
                    placeholder="请选择"
                    collapse-tags
                  >
                    <el-option
                      v-for="item in relationOptions"
                      :key="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                  <span>与学校关系:</span>
                </div>
                <div class="input_parent">
                  <el-date-picker
                    class="input input_daterange"
                    unlink-panels
                    v-model="where_year"
                    value-format="yyyy"
                    type="monthrange"
                  ></el-date-picker>
                  <span>入校时间:</span>
                </div>
                <div class="input_parent">
                  <!-- <el-input
                    class="input"
                    v-model="where_bill_status"
                    placeholder="请输入"
                    size
                  ></el-input> -->
                  <el-select
                    class="input"
                    v-model="where_bill_status"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in journalBillCertificateOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <span>票据:</span>
                </div>
                <div class="input_parent">
                  <!-- <el-input
                    class="input"
                    v-model="where_certificate_status"
                    placeholder="请输入"
                    size
                  ></el-input> -->
                  <el-select
                    class="input"
                    v-model="where_certificate_status"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in journalBillCertificateOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <span>证书:</span>
                </div>
                <div class="input_parent">
                  <el-select
                    class="input"
                    v-model="where_alumni_type"
                    placeholder="请选择"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="item in alumniTypeOptions"
                      :key="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                  <span>校友类别:</span>
                </div>
                <div class="input_parent input_parent_Max">
                  <el-date-picker
                    class="input input_daterange"
                    value-format="yyyy.MM.dd"
                    v-model="where_journal_time"
                    style="width: 69%"
                    type="daterange"
                    placeholder="请选择"
                  ></el-date-picker>
                  <span>捐助时间:</span>
                </div>
              </div>
            </div>
            <div class="main_head_right">
              <el-button type="primary" @click="query()">查询</el-button>
              <el-button @click="reset()">重置</el-button>
              <el-button type="text" @click="queryMoreShow()">{{
                queryMoreShowTitle
              }}</el-button>
              <span
                v-bind:class="[
                  queryMoreShowFlag ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                ]"
                @click="queryMoreShow()"
              ></span>
            </div>
          </div>
          <div style="clear: both"></div>

          <div style="margin-top: 10px">
            <el-dropdown
              @command="handleDialogCommand"
              placement="bottom-start"
            >
              <el-button>
                <i class="el-icon-s-operation el-icon--left"></i> 批量操作
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="exportSelect"
                  >导出选中信息</el-dropdown-item
                >
                <el-dropdown-item command="exportAisJournal"
                  >导出查询列表</el-dropdown-item
                >
                <el-dropdown-item command="exportAisJournalSum"
                  >导出总和列表</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <i
              class="el-icon-setting setTabBabel"
              style="margin-top: 10px"
              @click="showSetTabBabelDrawer()"
            ></i>
          </div>
          <div class="selectTitle" v-if="selectSize > 0">
            <span class="el-icon-info" style="color: #2383e0"></span>
            <span style="margin-left: 10px">已选择</span>
            <span class="selectTitleNum">{{ selectSize }}</span>
            <span>条信息</span>
            <el-button
              type="text"
              class="selectTitleClear"
              @click="cleanTable()"
              >清空</el-button
            >
          </div>

          <el-table
            v-loading="tableLoading"
            ref="multipleTable"
            :data="tableData"
            @row-click="toDetails"
            @sort-change="changeTableSort"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" min-width="1"></el-table-column>
            <el-table-column
              prop="student_no"
              v-if="checkList.indexOf('学号') > -1"
              label="学号"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="name_cn"
              v-if="checkList.indexOf('中文姓名') > -1"
              label="中文姓名"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="name_en"
              v-if="checkList.indexOf('英文姓名') > -1"
              label="英文姓名"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="programme"
              v-if="checkList.indexOf('专业') > -1"
              label="专业"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <!-- <el-table-column
              prop="journal_id"
              v-if="checkList.indexOf('捐助ID')>-1"
              label="捐助ID"
              min-width="2"
              sortable="custom"
            ></el-table-column> -->
            <el-table-column
              prop="journal_time"
              v-if="checkList.indexOf('捐助时间') > -1"
              label="捐助时间"
              min-width="3"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="relation"
              v-if="checkList.indexOf('与学校关系') > -1"
              label="与学校关系"
              min-width="3"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="year"
              v-if="checkList.indexOf('入校时间') > -1"
              label="入校时间"
              min-width="3"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="content"
              v-if="checkList.indexOf('捐助内容') > -1"
              label="捐助内容"
              min-width="3"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="bill_status"
              v-if="checkList.indexOf('票据') > -1"
              label="票据"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="certificate_status"
              v-if="checkList.indexOf('证书') > -1"
              label="证书"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="money"
              v-if="checkList.indexOf('捐助金额') > -1"
              label="捐助金额"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="type"
              v-if="checkList.indexOf('捐助类型') > -1"
              label="捐助类型"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="alumni_type"
              v-if="checkList.indexOf('校友类别') > -1"
              label="校友类别"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="is_bachelors_masters"
              v-if="checkList.indexOf('是否本硕连读') > -1"
              label="是否本硕连读"
              min-width="2"
            ></el-table-column>
            <el-table-column
              prop="remark"
              v-if="checkList.indexOf('备注') > -1"
              label="备注"
              min-width="2"
              sortable="custom"
            ></el-table-column>
          </el-table>
          <div class="elPaginationDiv">
            <el-pagination
              :key="elementui_page_key"
              class="elPagination"
              background
              layout="prev, pager, next"
              :page-size="pageMaxSize"
              :page-count="pageCount"
              :current-page="currentPage"
              @current-change="currentChange"
            ></el-pagination>
            <span class="paginationPageNum"
              >第{{ thispageNum }}条，总共{{ recordCount }}条</span
            >
          </div>
        </el-main>
        <export-ais-journal-dialog
          ref="_exportAisJournalDialog"
        ></export-ais-journal-dialog>
        <ExportAisJournalSumDialog
          ref="_exportAisJournalSumDialog"
        ></ExportAisJournalSumDialog>
        <journals-table-label-drawer
          ref="_journalsTableLabelDrawer"
          @toBackCheckList="backCheckList"
        ></journals-table-label-drawer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { URL_PATH, LIST_PAGE_MAX_SIZE } from "@/config/config";
import * as Constant from "@/utils/constant.js";
import * as StrUtils from "@/utils/strUtils.js";
import * as CApi from "@/api/constant_api.js";
import * as Api from "@/api/api.js";
import leftMeun from "@/components/layout/leftMeun";
import headerLayout from "@/components/layout/headerLayout";
import headRight from "@/components/layout/headRight";
import exportAisJournalDialog from "@/components/dialog/exportAisJournalDialog";
import ExportAisJournalSumDialog from "@/components/dialog/exportAisJournalSumDialog";
import journalsTableLabelDrawer from "@/components/drawer/journalsTableLabelDrawer";

var multipleSelectionMap = new Map(); // 多页选中数组总数

export default {
  components: {
    leftMeun,
    headerLayout,
    headRight,
    exportAisJournalDialog,
    ExportAisJournalSumDialog,
    journalsTableLabelDrawer
  },
  // beforeRouteLeave(to, from, next) {
  //   console.log(to)
  //   from.meta.keepAlive = to.path == '/data/journal-details' || to.path == '/data/journal-details-manual'
  //   next()
  // },
  data() {
    return {
      tableLoading: false,
      meunItem: null,
      meunTitle: " 捐助信息列表",
      queryMoreShowFlag: false,
      queryMoreShowTitle: "展开",
      timeOutTimer: "",
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      pageCount: 0,
      selectSize: 0,
      recordCount: 0,
      thispageNum: "1-" + LIST_PAGE_MAX_SIZE,
      otherPageSelectSize: 0, //其他页选中的数量
      changExcelDialogVisible: false,
      changSiDialogVisible: false,
      changeExportInfoDialog: false,
      exportAisJournalRequest: false,
      exportAisJournalSumRequest: false,

      currentPage: 1,
      order: "",
      where_student_no: "",
      where_name: "",
      where_programme: "",
      where_journal_time: [],
      where_content: "",
      where_money: "",
      where_type: "",
      where_remark: "",
      where_relation: "",
      where_year: [],
      where_bill_status: "",
      where_certificate_status: "",
      where_alumni_type: [],

      tableData: [],
      multipleSelection: [], // 单页选中数组
      checkList: Constant.journals_table_lable_base,
      checkListAll: Constant.journals_table_lable_base,
      programmeOptions: Constant.programme_options,
      relationOptions: Constant.relation_options, //与学校关系
      journalTypeOptions: Constant.journal_type_options, //捐赠类型
      journalBillCertificateOptions: Constant.journal_bill_certificate_options, //票据 证书
      alumniTypeOptions: []
    };
  },
  mounted() {
    var that = this;
    document.onkeydown = function(e) {
      const keyCode = event.keyCode
        ? event.keyCode
        : event.which
        ? event.which
        : event.charCode;
      // 回车键查询
      if (keyCode == 13) that.query();
    };
  },
  created() {
    this.elementui_page_key++;
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem;
      this.meunTitle = this.meunItem.name;
      // 获取操作日志列表
      this.getAisJournal();
      this.getProgrammeOptions();
      this.getAlumniTypeOptions();
    },
    showSetTabBabelDrawer() {
      this.$nextTick(() => {
        this.$refs._journalsTableLabelDrawer.show(this.checkList);
      });
    },
    exportList() {
      let ids = this.getUserIds();
      if (ids.length == 0) {
        this.$message.error("至少选中一条数据");
        return;
      }
      ids = JSON.stringify(ids);
      this.$nextTick(() => {
        this.$refs._exportAisJournalDialog.show(
          this.checkList,
          this.order,
          this.where_student_no,
          this.where_name,
          this.where_programme,
          this.where_journal_time,
          this.where_content,
          this.where_money,
          this.where_type,
          this.where_remark,
          this.where_relation,
          this.where_year,
          this.where_bill_status,
          this.where_certificate_status,
          this.where_alumni_type,
          ids
        );
      });
    },
    exportAisJournal() {
      if (this.recordCount == 0) {
        this.$message.error("列表无数据，无法导出");
        return;
      }
      this.$nextTick(() => {
        this.$refs._exportAisJournalDialog.show(
          this.checkList,
          this.order,
          this.where_student_no,
          this.where_name,
          this.where_programme,
          this.where_journal_time,
          this.where_content,
          this.where_money,
          this.where_type,
          this.where_remark,
          this.where_relation,
          this.where_year,
          this.where_bill_status,
          this.where_certificate_status,
          this.where_alumni_type
        );
      });
    },
    exportAisJournalSum() {
      if (this.recordCount == 0) {
        this.$message.error("列表无数据，无法导出");
        return;
      }
      this.$nextTick(() => {
        this.$refs._exportAisJournalSumDialog.show(
          this.where_student_no,
          this.where_name,
          this.where_programme,
          this.where_journal_time,
          this.where_year,
          this.where_relation
        );
      });
    },
    // 查看捐助详情 details
    toDetails(row, column, event) {
      let manual = "donationApplets" == row.type_en;
      Api.verifyApi(
        manual ? CApi.api_getAppletsDonationInfo : CApi.api_getDonationInfo,
        verify => {
          if (verify) {
            let path = manual
              ? "/data/journal-details"
              : "/data/journal-details-manual";
            this.$router.push({
              path: path,
              query: {
                list: true,
                id: row.id
              }
            });
          }
        }
      );
    },
    // 选择列表显示字段
    backCheckList(list) {
      this.checkList = list;
    },
    // 批量操作弹窗
    handleDialogCommand(command) {
      let _this = this;
      switch (command) {
        case "exportAisJournal":
          Api.verifyApi(CApi.api_exportAisJournal, verify => {
            if (verify) {
              this.exportAisJournalRequest = true;
              this.getAisJournal();
            }
          });
          break;
        case "exportAisJournalSum":
          Api.verifyApi(CApi.api_exportAisJournalSum, verify => {
            if (verify) {
              this.exportAisJournalSumRequest = true;
              this.getAisJournal();
            }
          });
          break;
        case "exportSelect":
          Api.verifyApi(CApi.api_exportAisJournal, verify => {
            if (verify) {
              this.exportList();
            }
          });
          break;
      }
    },
    // 地区选择
    handleRegionChange(value) {
      this.where_organization_province = CodeToText[value[0]];
      this.where_organization_city = CodeToText[value[1]];
    },
    currentChange(val) {
      this.elementui_page_key++;
      this.otherPageSelectSize += this.multipleSelection.length;
      multipleSelectionMap.set(this.currentPage, this.multipleSelection);
      console.log(multipleSelectionMap);

      this.otherPageSelectSize = 0;
      var that = this;
      multipleSelectionMap.forEach(function(key, value, index) {
        if (value != val) {
          that.otherPageSelectSize += key.length;
        }
      });
      this.currentPage = val;
      this.getAisJournal();
    },
    // 列表选中监听
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
      this.setShowBatchBtnState(this.multipleSelection.length);
    },
    // 排序
    changeTableSort(column) {
      this.order = StrUtils.getPropOrder(column);
      this.query();
    },
    // 获取专业
    getProgrammeOptions: function() {
      this.$api
        .getColumnValue({
          token: localStorage.getItem("token"),
          field: "programme"
        })
        .then(({ data }) => {
          this.programmeOptions = data.Data.programme;
        })
        .catch(({ error }) => {
          console.log(error);
        });
    },
    // 获取校友类别
    getAlumniTypeOptions() {
      this.$api
        .bindAisInfoFieldArr({ field: "alumni_type" })
        .then(({ data }) => {
          this.alumniTypeOptions = data.Data.alumni_type;
        })
        .catch(({ error }) => {
          console.log(error);
        });
    },
    // 服务端获取数据
    getAisJournal: function() {
      // var time = ''
      // if (this.where_journal_time.length > 0) {
      //   time = this.where_journal_time[0] + '-' + this.where_journal_time[1]
      // }
      // var where_year = ''
      // if (!StrUtils.isEmpty(this.where_year)) {
      //   where_year = this.where_year[0] + '-' + this.where_year[1]
      // }
      this.tableLoading = true;
      this.$api
        .getAisJournal({
          token: localStorage.getItem("token"),
          page: this.currentPage,
          limit: this.pageMaxSize,

          order: this.order,
          where_student_no: this.where_student_no,
          where_name: this.where_name,
          where_programme: StrUtils.replaceFields(
            this.where_programme.toString()
          ),
          where_year:
            this.where_year == undefined || this.where_year.length == 0
              ? ""
              : this.where_year[0] + "-" + this.where_year[1],
          where_journal_time:
            this.where_journal_time == undefined ||
            this.where_journal_time.length == 0
              ? ""
              : this.where_journal_time[0] + "-" + this.where_journal_time[1],
          where_content: this.where_content,
          where_money: this.where_money,
          where_type: StrUtils.replaceFields(this.where_type.toString()),
          where_remark: this.where_remark,

          where_relation: this.where_relation,
          where_bill_status: this.where_bill_status,
          where_certificate_status: this.where_certificate_status,
          where_alumni_type: StrUtils.replaceFields(
            this.where_alumni_type.toString()
          )
        })
        .then(({ data }) => {
          this.recordCount = data.Data.recordCount;
          var currentPage = data.Data.currentPage;
          var startIndex = (currentPage - 1) * this.pageMaxSize + 1;
          var endIndex = startIndex + this.pageMaxSize - 1;
          if (endIndex > this.recordCount) {
            endIndex = this.recordCount;
          }
          this.thispageNum = startIndex + "-" + endIndex;
          this.pageCount = data.Data.pageCount;
          this.tableData = data.Data.model;

          this.tableData.forEach(info => {
            var region = "";
            if (!StrUtils.isEmpty(info.organization_nation)) {
              region += info.organization_nation;
            }
            if (!StrUtils.isEmpty(info.organization_province)) {
              region += info.organization_province;
            }
            if (!StrUtils.isEmpty(info.organization_city)) {
              region += info.organization_city;
            }
            info.region = region;

            info.bill_status = StrUtils.getBillStatus(info.bill_status);
            info.certificate_status = StrUtils.getCertificateStatus(
              info.certificate_status
            );
            info.is_bachelors_masters = StrUtils.yesOrNo(
              info.is_bachelors_masters
            );
          });

          this.timeOutTimer = setTimeout(this.toggleRowSelectionn, 10);
          this.tableLoading = false;
          if (this.exportAisJournalRequest) {
            this.exportAisJournal();
          }
          this.exportAisJournalRequest = false;
          if (this.exportAisJournalSumRequest) {
            this.exportAisJournalSum();
          }
          this.exportAisJournalSumRequest = false;
        })
        .catch(({ error }) => {
          this.tableLoading = false;
          this.exportAisJournalRequest = false;
          this.exportAisJournalSumRequest = false;
          if (error != undefined) {
            console.log(error);
          }
        });
    },
    // 恢复勾选已选中
    toggleRowSelectionn() {
      if (multipleSelectionMap.size == 0) return;
      var array = multipleSelectionMap.get(this.currentPage);
      if (array == undefined || array.length == 0) return;
      var arr = JSON.parse(JSON.stringify(array));
      this.tableData.forEach(tData => {
        arr.forEach(tData1 => {
          if (tData.id === tData1.id) {
            this.$refs.multipleTable.toggleRowSelection(tData, true);
          }
        });
      });
    },
    // 批量操作显示状态修改
    setShowBatchBtnState(size) {
      this.selectSize = size + this.otherPageSelectSize;
    },
    // 获取选中的用户id 数组
    getUserIds: function() {
      multipleSelectionMap.set(this.currentPage, this.multipleSelection);
      var userIds = [];
      multipleSelectionMap.forEach(function(key, value, index) {
        key.forEach(user => {
          userIds.push(user.id);
        });
      });
      return userIds;
    },
    // 查询
    query: function() {
      this.currentPage = 1;
      this.getAisJournal();
    },
    // 搜索重置
    reset: function() {
      this.$refs.multipleTable.clearFilter();
      multipleSelectionMap.clear();

      this.order = "";
      this.where_student_no = "";
      this.where_name = "";
      this.where_programme = "";
      this.where_content = "";
      this.where_money = "";
      this.where_type = "";
      this.where_remark = "";
      this.where_journal_time = [];

      this.where_relation = "";
      this.where_year = [];
      this.where_bill_status = "";
      this.where_certificate_status = "";
      this.where_alumni_type = [];

      this.exportAisJournalRequest = false;
      this.exportAisJournalSumRequest = false;
      this.otherPageSelectSize = 0;
      this.setShowBatchBtnState(0);
      this.query();
    },
    queryMoreShow() {
      this.queryMoreShowFlag = !this.queryMoreShowFlag;
      this.queryMoreShowTitle = this.queryMoreShowFlag ? "收起" : "展开";
    },
    //清空已选表格
    cleanTable: function() {
      multipleSelectionMap.clear();
      this.otherPageSelectSize = 0;
      this.setShowBatchBtnState(0);
      this.$refs.multipleTable.clearSelection();
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeOutTimer);
  }
};
</script>

<style lang="less" scoped>
.main {
  margin: 10px 20px;
  background-color: #fff;
  border-radius: 5px;
}
.main_head {
  width: 100%;
}
.main_head_left {
  margin-left: -20px;
  width: 85%;
  float: left;
}
.selectTitle {
  padding-left: 10px;
  margin-top: 15px;
  background-color: #eff9fe;
  border-radius: 3px;
  border: 1px solid #2383e0;
  height: 40px;
  line-height: 40px;
}
.selectTitleNum {
  color: #2383e0;
}
.selectTitleClear {
  color: #2383e0;
  margin-left: 20px;
  cursor: hand;
}
</style>
<style lang="less">
.el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 60%;
}
</style>



// WEBPACK FOOTER //
// src/pages/dataMgr/listJournals.vue